module.exports = __webpack_public_path__ + "img/letter.c5cd5098.png";